jQuery(document).ready(function($) {
  // window.cookieconsent.initialise({
  //   cookie: {
  //     domain: '.localhost'
  //   },
  //   theme: 'classic',
  //   position: 'bottom-right',
  //   palette: {
  //     popup: { background: '#fff' },
  //     button: { background: '#0080FF' }
  //   },
  //   //GA cookies will always be loaded since they are 1st party and used for analytics on the site
  //   // onStatusChange: function(status) {
  //   //  console.log(this.hasConsented() ?
  //   //   'enable cookies' : 'disable cookies');
  //   // },
  //   // onNoCookieLaw: function (countryCode, country) {
  //   //   console.log('nolaw');
  //   // },
  //   law: {
  //     regionalLaw: true
  //   },
  //   location: true,
  //   content: {
  //     header: 'Cookies we use',
  //     message: 'This website uses cookies to improve your experience, tailor messaging, and help us understand how our site is being used. ',
  //     dismiss: 'Got it!',
  //     allow: 'Allow cookies',
  //     deny: 'Decline',
  //     link: 'Cookie Policy',
  //     href: '/cookie-policy',
  //     close: '&#x274c;',
  //     policy: 'Cookie Policy',
  //     target: '/cookie-policy'
  //   }
  // });

  // $('.lazy').lazy({
  //   enableThrottle: true,
  //   throttle: 250,
  //   threshold: 600,
  //   afterLoad: function(element) {
  //     setTimeout(function() {
  //       element.parent().addClass('lazy-loaded');
  //       //If color picker already has been used, don't override that color with the default one
  //       if (!element.parent().attr('style')) {
  //         element.parent().css('background-color', '#363f47');
  //       }
  //     }, 800);
  //   }
  // });

  //Facebook and Google tracking
  $('#buy-pro-package').on('click', function() {
    window.dataLayer.push({
      event: 'addToCart',
      product: 'Pro Package',
      value: 250
    });

    fbq('track', 'AddToCart', {
      value: 250,
      content_ids: 'vast-pro',
      currency: 'USD'
    });
  });

  $('#buy-core-set').on('click', function() {
    window.dataLayer.push({
      event: 'addToCart',
      product: 'Core Set',
      value: 90
    });

    fbq('track', 'AddToCart', {
      value: 90,
      content_ids: 'vast-core',
      currency: 'USD'
    });
  });

  if ($('#icons-color-picker').length) {
    var colorPicker = new iro.ColorPicker('#icons-color-picker', {
      // color picker options
      // Option guide: https://iro.js.org/guide.html#color-picker-options
      width: 150,
      color: '#0080FF',
      borderWidth: 1,
      borderColor: '#fff'
    });

    colorPicker.on(['color:change'], function(color) {
      $('.category-container li > span').css(
        'background-color',
        color.hexString
      );
    });
  }

  $('.toggle-color').on('click', function() {
    $(this)
      .parent()
      .find('.color-picker-container')
      .toggleClass('is-active');
  });

  $('.color-picker-close').on('click', function() {
    $(this)
      .parent()
      .removeClass('is-active');
  });

  if ($('#custom-set-form').length) {
    var colorConfig = {
      width: 80,
      color: '#0080FF',
      borderWidth: 1,
      borderColor: '#fff'
    };
    var colorPicker1 = new iro.ColorPicker('#color-picker-1', colorConfig);
    var colorPicker2 = new iro.ColorPicker('#color-picker-2', colorConfig);
    var colorPicker3 = new iro.ColorPicker('#color-picker-3', colorConfig);

    //Set value in form field and colorize the icons.
    colorPicker1.on(['color:change'], function(color) {
      $('#color-picker-1-input').val(color.hexString);
      $('#color-1-icons li > span').css('background-color', color.hexString);
      $('#color-picker-1-input')
        .parsley()
        .reset();
    });

    //Set value in picker when color is input directly into the field. But only when regex matches
    $('#color-picker-1-input').on('input', function() {
      var val = $(this).val();
      var regex = /^(#){1}([a-fA-F0-9]){6}$/;

      if (val.match(regex)) {
        colorPicker1.color.set(val);
      }
    });

    //Set value in form field and colorize the icons.
    colorPicker2.on(['color:change'], function(color) {
      $('#color-picker-2-input').val(color.hexString);
      $('#color-2-icons li > span').css('background-color', color.hexString);
      $('#color-picker-2-input')
        .parsley()
        .reset();
    });

    //Set value in picker when color is input directly into the field. But only when regex matches
    $('#color-picker-2-input').on('input', function() {
      var val = $(this).val();
      var regex = /^(#){1}([a-fA-F0-9]){6}$/;

      if (val.match(regex)) {
        colorPicker2.color.set(val);
      }
    });

    //Set value in form field and colorize the icons.
    colorPicker3.on(['color:change'], function(color) {
      $('#color-picker-3-input').val(color.hexString);
      $('#color-3-icons li > span').css('background-color', color.hexString);
      $('#color-picker-3-input')
        .parsley()
        .reset();
    });

    //Set value in picker when color is input directly into the field. But only when regex matches
    $('#color-picker-3-input').on('input', function() {
      var val = $(this).val();
      var regex = /^(#){1}([a-fA-F0-9]){6}$/;

      if (val.match(regex)) {
        colorPicker3.color.set(val);
      }
    });
  }

  $('#custom-set-form button:not(.btn-secondary)').click(function(e) {
    e.preventDefault();
  });

  //BS Tooltips
  $(function() {
    $('[data-toggle="tooltip"]').tooltip({ html: true });
  });

  //Menu Toggle
  $('.hamburger').on('click', function() {
    $(this).toggleClass('is-active');
    $('#main-nav').toggleClass('is-active');
  });

  //Categories Toggle
  $('#category-nav-toggle').on('click', function() {
    $(this).toggleClass('is-active');
  });

  $('#examples').slick({
    slidesToShow: 1,
    dots: true,
    arrows: false,
    fade: true
  });

  //Smooth Scroll
  $('a[href^="#"]').on('click', function(e) {
    e.preventDefault();
    var target = this.hash,
      $target = $(target);
    $('html, body')
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top + -140
        },
        900,
        'swing'
      );
  });

  //Contact Form
  $('#reason').on('change', function() {
    //use toggle for ease of use
    $('.support-form-text').toggleClass(
      'show-support-text',
      this.value == 'support'
    );
  });

  if ($('#contact-form').length > 0) {
    $('#contact-form')
      .parsley()
      .on('field:validated', function() {
        var ok = $('.parsley-error').length === 0;
        $('.bs-callout-info').toggleClass('hidden', !ok);
        $('.bs-callout-warning').toggleClass('hidden', ok);
      });

    $('#contact-form').on('submit', function(e) {
      e.preventDefault();
      if (
        $(this)
          .parsley()
          .isValid()
      ) {
        $.ajax({
          url: '/assets/php/send.php',
          data: $(this).serialize(),
          type: 'POST',
          success: function() {
            if ($('#reason').val() === 'support') {
              $('#success .block-callout').append(
                "<h3>Your support request has been sent.</h3> <p>We'll get back to you within one business day.</p>"
              );
            } else {
              $('#success .block-callout').append(
                "<h3>Your message is on its way.</h3> <p>Thanks for taking the time to reach out. We'll get back to you within a few business days.</p>"
              );
            }
            $('#success').fadeIn(500);
            $('#form-content').hide();
          },
          error: function() {
            $('#success')
              .empty()
              .html(
                '<p class="mt-4 text-danger">There was a problem sending your message. Please try sending again.</p>'
              )
              .fadeIn(500);
          }
        });
      }
    });
  }

  if ($('#subscribe-form').length > 0) {
    $('#subscribe-form')
      .parsley()
      .on('field:validated', function() {
        var ok = $('.parsley-error').length === 0;
        $('.bs-callout-info').toggleClass('hidden', !ok);
        $('.bs-callout-warning').toggleClass('hidden', ok);
      });

    $('#subscribe-form').on('submit', function(e) {
      e.preventDefault();
      if (
        $(this)
          .parsley()
          .isValid()
      ) {
        $.ajax({
          url: '/assets/php/subscribe.php',
          data: $(this).serialize(),
          type: 'POST',
          success: function() {
            $('#success').append(
              "<h1 class='mb-3'>Thank you!</h1><p class='lead-text mt-0'>Here's your free set.😊</p><a href='/assets/downloads/vastdrone-icons-free-set-v1.zip' id='download-free-set' class='btn btn-action mt-4 mb-5 w-100'>Download Set</a>"
            );
            window.dataLayer.push({
              event: 'freeSetSubscribe'
            });
            fbq('trackCustom', 'FreeSetSubscribe');

            $('#success').fadeIn(500);
            $('#form-content,#hero-intro').hide();
          },
          error: function() {
            $('#success')
              .empty()
              .html(
                '<p class="mt-4 text-danger">There was a problem subscribing you. Please try again.</p>'
              )
              .fadeIn(500);
          }
        });
      }
    });
  }

  /*
   * parsley.js - hexcolor validator | Maarten Paauw | http://parsleyjs.org/ | http://www.graciousstudios.nl/
   * Check if value is a valid hex color.
   * Formatted hex color: #FFFFFF
   * Example hexcolor: data-parsley-hexcolor
   */

  window.Parsley.addValidator('hexcolor', {
    requirementType: 'regexp',
    validateString: function(value) {
      var hexcolor = value,
        regex = /^(#){1}([a-fA-F0-9]){6}$/;

      return hexcolor.match(regex) ? true : false;
    },
    messages: {
      en:
        "Something doesn't look right. Hex color should start with # character and be followed by combination of six letters and/or numbers. Example: #ac82ff."
    }
  });

  //Custom Set Form
  if ($('#custom-set-form').length > 0) {
    $('#custom-set-form')
      .parsley()
      .on('field:validated', function() {
        var ok = $('.parsley-error').length === 0;
        $('.bs-callout-info').toggleClass('hidden', !ok);
        $('.bs-callout-warning').toggleClass('hidden', ok);
      });

    $('#custom-set-form').on('submit', function(e) {
      e.preventDefault();
      if (
        $(this)
          .parsley()
          .isValid()
      ) {
        $.ajax({
          url: '/assets/php/custom-set.php',
          data: $(this).serialize(),
          type: 'POST',
          success: function() {
            $('#success').fadeIn(500);
            $('#form-content').hide();
          },
          error: function() {
            $('#success')
              .empty()
              .html(
                '<p class="mt-4 text-danger">There was a problem submitting your custom set request. Please try submitting again.</p>'
              )
              .fadeIn(500);
          }
        });
      }
    });
  }
});
